//  Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved.
import { Component, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EVENT_TYPES, SEVERITY } from '../../../types/events';
import { EventsService } from '../../../services/events-service';
import { NotificationService } from '../../../services/notification-service';
import { UntilDestroy } from '@ngneat/until-destroy';

interface ISeverity {
    value: SEVERITY;
    displayValue: string;
}

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-create-admin-event',
    templateUrl: './create-admin-event.component.html',
    styleUrls: ['./create-admin-event.component.scss'],
    standalone: false
})
export class CreateAdminEventComponent {
    @ViewChild('descriptionInput') descriptionInput;
    severity: ISeverity
    severities: ISeverity[];
    description = '';
    detail = '';
    defaultDescription = this.translate.instant('ADMIN_EVENT_DESC_DEFAULT');

    constructor(
        private dialogRef: MatDialogRef<CreateAdminEventComponent>,
        private translate: TranslateService,
        private eventsService: EventsService,
        private notification: NotificationService,
    ) {
        this.severities = [
            {'value': 10, 'displayValue': translate.instant('SEVERITY_DEBUG')},
            {'value': 20, 'displayValue': translate.instant('SEVERITY_INFO')},
            {'value': 30, 'displayValue': translate.instant('SEVERITY_WARNING')},
            {'value': 40, 'displayValue': translate.instant('SEVERITY_ERROR')}
        ];
        // Default to severity of info
        this.severity = this.severities.find(s => s.value === 20);
        this.description = this.defaultDescription;
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        const severity: SEVERITY = this.severity.value;
        const type = EVENT_TYPES.ADMIN_EVENT;
        const description = this.description || this.defaultDescription;
        const detail = this.detail;
        this.eventsService.postEvent({severity, type, description, detail})
            .subscribe({
                next: (result) => this.dialogRef.close(result),
                error: () => {
                    const errorTitle = this.translate.instant('ERROR_CREATE_ADMIN_EVENT_TITLE');
                    const errorDescription = this.translate.instant('ERROR_CREATE_ADMIN_EVENT_DESC');
                    this.notification.showError(errorDescription, errorTitle);
                },
                complete: () => this.notification.showSuccess(this.translate.instant('ADMIN_EVENT_CREATED_MSG'))
        });
    }

}
